<template>
  <div class="informationTemplate-tree-bd">
    <el-dialog
      v-drag-dialog
      :title="model.title"
      :visible.sync="visible"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="dialog-body">
        <!-- 用户信息 -->
        <el-form :model="form" ref="form">
          <el-row>

            <el-row :gutter="8">
                <el-col :span="18" >
                  <el-form-item
                    :label="$t('crm_partner_contacts_dialog.lxrxm')"
                    prop="contactName"
                    :rules="rules.contactName"
                  >
                    <el-input v-model="form.contactName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item  label="" >
                    <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <el-button style="width:100%;" @click="onContact" :disabled="model.type === 'edit'">{{ $t('crm_partner_contacts_dialog.xuan_ze') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            <el-col :span="24">
              <el-form-item
                :label="$t('crm_partner_contacts_dialog.lian_xi_ren_zhi_wu')"
                prop="post"
                :rules="rules.post"
              >
                <el-input v-model="form.post"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('crm_partner_contacts_dialog.lian_xi_ren_dian_hua')"
                prop="mobilePhone"
                :rules="rules.mobilePhone"
              >
                <el-input v-model="form.mobilePhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('crm_partner_contacts_dialog.lxryx')"
                prop="email"
                :rules="rules.email"
              >
                <el-input v-model="form.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveContact">{{
          $t('Common.com_confirm')
        }}</el-button>
      </div>
      <partner-contactsSelect-dialog
        v-if="dialogVisible"
        :model="dialogModel"
        @close="dialogVisible = false"
        @success="onSelect"
      >
      </partner-contactsSelect-dialog>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partnerContactsSelectDialog from './partner_contactsSelect_dialog';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: ''
        };
      }
    }
  },
  components: {
    partnerContactsSelectDialog
  },
  data() {
    return {
      visible: false,
      // 用于编辑
      form: {
        contactName: '',
        post: '',
        mobilePhone: '',
        email: '',
        // id
        contactId: '',
        partnerId: '',
        partnerOrgId: '',
        contactType: ''
      },
      // 用于新增
      formContact: {
        partnerId: '',
        partnerOrgId: '',
        partnerCoopcontacts: []
      },
      // 选择联系人
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        contactName: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ],
        post: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]), }
        ],
        mobilePhone: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 15, message: this.$t('Common.com_rules_length_max', [15]), }
        ],
        email: [
          { required: true, message: this.$t('Common.com_required') },
          {
            type: 'email',
            message: this.$t('crm_partner_contacts_dialog.qtxzqdyx')
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ]
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form = JSON.parse(this.resetForm);
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      if (this.model.type === 'add') {
        // 清空重置值
        this.formContact.partnerId = this.data.partnerId;
        this.formContact.partnerOrgId = this.data.partnerOrgId;
      }
      if (this.model.type === 'edit') {
        // 赋值
        this.$setFormatData(this.form, this.data);
      }
    },
    onContact() {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_partner_contacts_dialog.xuan_ze_yong_hu');
    },
    onSelect(item) {
      this.form.contactName = item.realName;
      // post
      this.form.post = this.$t('crm_partner_contacts_dialog.ye_wu_fu_ze_ren');
      this.form.mobilePhone = item.mobile;
      this.form.email = item.email;
      this.form.contactType = 'coopcontact';// 联系负责人
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveContact: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddContact();
        }
        if (this.model.type === 'edit') {
          this.saveEditContact();
        }
      });
    },
    // 保存新增联系人
    saveAddContact: function () {
      this.formContact = this.form;
      this.formContact.partnerId = this.data.partnerId;
      this.formContact.partnerOrgId = this.data.partnerOrgId;
      this.formContact.contactType = this.form.contactType ? this.form.contactType : 'coopcontact';// 普通联系人
      this.$postJSON(apis.partnerContactAdd, this.formContact).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success'
          });
          this.$emit('success');
          this.closeDialog();
        }
      });
    },
    // 保存编辑联系人
    saveEditContact: function () {
      this.$postJSON(`${apis.partnerContactUpdate}`, this.form).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_modify_success'),
            type: 'success'
          });
          this.$emit('success', this.form);
          this.closeDialog();
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
